import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { getExam } from 'common/apis';
import { examUrl } from 'common/config';
import { View, Image } from 'ui';
import styles from 'components/initial/styles';

const examIdUrl = {
  1: examUrl.toefl,
  2: examUrl.ielts,
  // 3: examUrl.gre,
  // 65: examUrl.base,
};

const baseExamUrl = examUrl.base

// 默认设置axios发起请求时带上cookie
// axios.defaults.withCredentials = true;

// 入口页
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isError: false,
      newHref: '',
    };
  }

  async componentDidMount() {
    const { pathname, host, href } = global.location;
    let exerciseId = '';
    let answerId = '';
    let practicePackageId = '';
    let practiceId = '';
    let questionId = '';
    if (pathname.indexOf('/init/') !== -1) {
      const params = pathname.match(/\/init\/(.*?)\/(\d+)/);
      const mode = params && params[1];
      if (mode === 'question') {
        questionId = params && params[2];
      } else if (mode === 'mock') {
        practicePackageId = params && params[2];
      } else if (mode === 'practice') {
        practiceId = params && params[2];
      } else if (mode === 'test') {
        const newHref = href.replace(host, baseExamUrl);
        this.setState({ newHref });
        return false;
      }
    } else if (pathname.indexOf('/report/') !== -1) {
      const params = pathname.match(/\/report\/(.*?)\/(\d+)/);
      const mode = params && params[1];
      if (mode === 'test') {
        const newHref = href.replace(host, baseExamUrl);
        this.setState({ newHref });
        return false;
      }
      exerciseId = params && params[2];
    } else if (pathname.indexOf('/machine-correct/') !== -1) {
      const params = pathname.match(/\/machine-correct\/(\d+)\/(\d+)/);
      answerId = params && params[2];
    } else if (pathname.indexOf('/correct/') !== -1) {
      const params = pathname.match(/\/correct\/(\d+)\/(\d+)/);
      exerciseId = params && params[2];
    } else if (pathname.indexOf('/entrance/') !== -1) {
      const newHref = href.replace(host, baseExamUrl);
      this.setState({ newHref });
      return false;
    } else if (pathname.indexOf('/listen/') !== -1) {
      const newHref = href.replace(host, baseExamUrl);
      this.setState({ newHref });
      return false;
    } else if (pathname.indexOf('/repeat/') !== -1) {
      const newHref = href.replace(host, examUrl.base2);
      this.setState({ newHref });
      return false;
    }
    const examData = await axios({
      url: `${getExam[1]}?exerciseId=${exerciseId}&answerId=${answerId}&practicePackageId=${practicePackageId}&practiceId=${practiceId}&questionId=${questionId}`,
      headers: {
        From: 1,
      },
      method: 'GET',
    });
    if (examData.data.code === 0 && examData.data.data && examData.data.data.id) {
      const newHref = href.replace(host, examIdUrl[examData.data.data.id] || baseExamUrl);
      this.setState({ newHref });
    } else {
      this.setState({ isError: true });
    }
  }

  render() {
    const { isLoaded, isError, newHref } = this.state;
    const isInIframe = decodeURIComponent(global.location.search.match(new RegExp('[?#&]isInIframe=([^?#&]+)', 'i')) ? RegExp.$1 : '');

    if (newHref && !isInIframe) {
      global.location.href = newHref;
    }

    if (!isLoaded && !isError && newHref && isInIframe) {
      return (
        <iframe
          title="iframe"
          style={{ overflow: 'visible', verticalAlign: 'top' }}
          ref="iframe"
          src={newHref}
          width="100%"
          height="100%"
          scrolling="no"
          frameBorder="0"
          allow="microphone"
        />
      );
    }

    return (
      <View className={styles.container}>
        {
          isLoaded && <Image
            className={styles.loading}
            src={require('components/assets/loading.gif')}
          />
        }
        {
          isLoaded && <View className={styles.text}>正在加载，请稍候...</View>
        }
        {
          isError && <Image
            className={styles.image}
            src={require('components/assets/fail.png')}
          />
        }
        {
          isError &&
            <View>
              <View className={styles.text}>题目加载失败...</View>
              <View className={styles.text}>请检查您是否已经登录或联系我们的客服人员</View>
              <View className={styles.text}>电话：400-011-9191</View>
            </View>
        }
      </View>
    );
  }
}

// 渲染
ReactDOM.render(
  <App />,
  global.document.getElementById('app'),
);



// WEBPACK FOOTER //
// ./src/index.js